const ParagraphBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="#ffd400" d="M2 2h20v20H2z" />
    <path d="M0 0v24h24V0zm22 22H2V2h20z" fill="#333" />
    <path fill="#fff" d="M10 8h4v4h-4z" />
    <path d="M10 14h6V6H8v12h2zm0-6h4v4h-4z" fill="#333" />
  </svg>
);

export default ParagraphBlockIcon;
